import { type Country } from './types';

const ICONS_API = 'https://static.elfsight.com/icons/';

/**
 * @deprecated use useGetCountries hook to get countries instead of this
 */
export const COUNTRIES = [
  {
    countryCode: 'AF',
    name: 'Afghanistan',
    phoneCode: '+93',
    iconSrc: `${ICONS_API}app-translator-afghanistan-multicolor.svg`
  },
  {
    countryCode: 'AL',
    name: 'Albania',
    phoneCode: '+355',
    iconSrc: `${ICONS_API}app-translator-albania-multicolor.svg`
  },
  {
    countryCode: 'AD',
    name: 'Andorra',
    phoneCode: '+376',
    iconSrc: `${ICONS_API}app-translator-andorra-multicolor.svg`
  },
  {
    countryCode: 'AO',
    name: 'Angola',
    phoneCode: '+244',
    iconSrc: `${ICONS_API}app-translator-angola-multicolor.svg`
  },
  {
    countryCode: 'AR',
    name: 'Argentina',
    phoneCode: '+54',
    iconSrc: `${ICONS_API}app-translator-argentina-multicolor.svg`
  },
  {
    countryCode: 'AM',
    name: 'Armenia',
    phoneCode: '+374',
    iconSrc: `${ICONS_API}app-translator-armenia-multicolor.svg`
  },
  {
    countryCode: 'AC',
    name: 'Ascension Island',
    phoneCode: '+247',
    iconSrc: `${ICONS_API}app-translator-ascension-island-multicolor.svg`
  },
  {
    countryCode: 'AU',
    name: 'Australia',
    phoneCode: '+61',
    iconSrc: `${ICONS_API}app-translator-australia-multicolor.svg`
  },
  {
    countryCode: 'AT',
    name: 'Austria',
    phoneCode: '+43',
    iconSrc: `${ICONS_API}app-translator-austria-multicolor.svg`
  },
  {
    countryCode: 'AZ',
    name: 'Azerbaijan',
    phoneCode: '+994',
    iconSrc: `${ICONS_API}app-translator-azerbaijan-multicolor.svg`
  },
  {
    countryCode: 'BH',
    name: 'Bahrain',
    phoneCode: '+973',
    iconSrc: `${ICONS_API}app-translator-bahrain-multicolor.svg`
  },
  {
    countryCode: 'BD',
    name: 'Bangladesh',
    phoneCode: '+880',
    iconSrc: `${ICONS_API}app-translator-bangladesh-multicolor.svg`
  },
  {
    countryCode: 'BB',
    name: 'Barbados',
    phoneCode: '+246',
    iconSrc: `${ICONS_API}app-translator-barbados-multicolor.svg`
  },
  {
    countryCode: 'BY',
    name: 'Belarus',
    phoneCode: '+375',
    iconSrc: `${ICONS_API}app-translator-belarus-multicolor.svg`
  },
  {
    countryCode: 'BE',
    name: 'Belgium',
    phoneCode: '+32',
    iconSrc: `${ICONS_API}app-translator-belgium-multicolor.svg`
  },
  {
    countryCode: 'BO',
    name: 'Bolivia',
    phoneCode: '+591',
    iconSrc: `${ICONS_API}app-translator-bolivia-multicolor.svg`
  },
  {
    countryCode: 'BA',
    name: 'Bosnia and Herzegovina',
    phoneCode: '+387',
    iconSrc: `${ICONS_API}app-translator-bosnia-and-herzegovina-multicolor.svg`
  },
  {
    countryCode: 'BR',
    name: 'Brazil',
    phoneCode: '+55',
    iconSrc: `${ICONS_API}app-translator-brazil-multicolor.svg`
  },
  {
    countryCode: 'BG',
    name: 'Bulgaria',
    phoneCode: '+359',
    iconSrc: `${ICONS_API}app-translator-bulgaria-multicolor.svg`
  },
  {
    countryCode: 'CV',
    name: 'Cabo Verde',
    phoneCode: '+238',
    iconSrc: `${ICONS_API}app-translator-cabo-verde-multicolor.svg`
  },
  {
    countryCode: 'KH',
    name: 'Cambodia',
    phoneCode: '+855',
    iconSrc: `${ICONS_API}app-translator-cambodia-multicolor.svg`
  },
  {
    countryCode: 'CM',
    name: 'Cameroon',
    phoneCode: '+237',
    iconSrc: `${ICONS_API}app-translator-cameroon-multicolor.svg`
  },
  {
    countryCode: 'CA',
    name: 'Canada',
    phoneCode: '+1',
    iconSrc: `${ICONS_API}app-translator-canada-multicolor.svg`
  },
  {
    countryCode: 'BQ',
    name: 'Caribbean Netherlands',
    phoneCode: '+599',
    iconSrc: `${ICONS_API}app-translator-caribbean-netherlands-multicolor.svg`
  },
  {
    countryCode: 'CL',
    name: 'Chile',
    phoneCode: '+56',
    iconSrc: `${ICONS_API}app-translator-chile-multicolor.svg`
  },
  {
    countryCode: 'CN',
    name: 'China',
    phoneCode: '+86',
    iconSrc: `${ICONS_API}app-translator-china-multicolor.svg`
  },
  {
    countryCode: 'CO',
    name: 'Colombia',
    phoneCode: '+57',
    iconSrc: `${ICONS_API}app-translator-colombia-multicolor.svg`
  },
  {
    countryCode: 'CR',
    name: 'Costa Rica',
    phoneCode: '+506',
    iconSrc: `${ICONS_API}app-translator-costa-rica-multicolor.svg`
  },
  {
    countryCode: 'HR',
    name: 'Croatia',
    phoneCode: '+385',
    iconSrc: `${ICONS_API}app-translator-croatia-multicolor.svg`
  },
  {
    countryCode: 'CU',
    name: 'Cuba',
    phoneCode: '+53',
    iconSrc: `${ICONS_API}app-translator-cuba-multicolor.svg`
  },
  {
    countryCode: 'CY',
    name: 'Cyprus',
    phoneCode: '+357',
    iconSrc: `${ICONS_API}app-translator-cyprus-multicolor.svg`
  },
  {
    countryCode: 'CZ',
    name: 'Czech Republic',
    phoneCode: '+420',
    iconSrc: `${ICONS_API}app-translator-czech-republic-multicolor.svg`
  },
  {
    countryCode: 'CD',
    name: 'Democratic Republic of the Congo',
    phoneCode: '+243',
    iconSrc: `${ICONS_API}app-translator-democratic-republic-of-the-congo-multicolor.svg`
  },
  {
    countryCode: 'DK',
    name: 'Denmark',
    phoneCode: '+45',
    iconSrc: `${ICONS_API}app-translator-denmark-multicolor.svg`
  },
  {
    countryCode: 'DO',
    name: 'Dominican Republic',
    phoneCode: '+1',
    iconSrc: `${ICONS_API}app-translator-dominican-republic-multicolor.svg`
  },
  {
    countryCode: 'EC',
    name: 'Ecuador',
    phoneCode: '+593',
    iconSrc: `${ICONS_API}app-translator-ecuador-multicolor.svg`
  },
  {
    countryCode: 'EG',
    name: 'Egypt',
    phoneCode: '+20',
    iconSrc: `${ICONS_API}app-translator-egypt-multicolor.svg`
  },
  {
    countryCode: 'SV',
    name: 'El Salvador',
    phoneCode: '+503',
    iconSrc: `${ICONS_API}app-translator-el-salvador-multicolor.svg`
  },
  {
    countryCode: 'ER',
    name: 'Eritrea',
    phoneCode: '+291',
    iconSrc: `${ICONS_API}app-translator-eritrea-multicolor.svg`
  },
  {
    countryCode: 'EE',
    name: 'Estonia',
    phoneCode: '+372',
    iconSrc: `${ICONS_API}app-translator-estonia-multicolor.svg`
  },
  {
    countryCode: 'SZ',
    name: 'Eswatini',
    phoneCode: '+268',
    iconSrc: `${ICONS_API}app-translator-eswatini-multicolor.svg`
  },
  {
    countryCode: 'ET',
    name: 'Ethiopia',
    phoneCode: '+251',
    iconSrc: `${ICONS_API}app-translator-ethiopia-multicolor.svg`
  },
  {
    countryCode: 'FI',
    name: 'Finland',
    phoneCode: '+358',
    iconSrc: `${ICONS_API}app-translator-finland-multicolor.svg`
  },
  {
    countryCode: 'FR',
    name: 'France',
    phoneCode: '+33',
    iconSrc: `${ICONS_API}app-translator-france-multicolor.svg`
  },
  {
    countryCode: 'PF',
    name: 'French Polynesia',
    phoneCode: '+689',
    iconSrc: `${ICONS_API}app-translator-french-polynesia-multicolor.svg`
  },
  {
    countryCode: 'GM',
    name: 'Gambia',
    phoneCode: '+220',
    iconSrc: `${ICONS_API}app-translator-gambia-multicolor.svg`
  },
  {
    countryCode: 'GE',
    name: 'Georgia',
    phoneCode: '+995',
    iconSrc: `${ICONS_API}app-translator-georgia-multicolor.svg`
  },
  {
    countryCode: 'DE',
    name: 'Germany',
    phoneCode: '+49',
    iconSrc: `${ICONS_API}app-translator-germany-multicolor.svg`
  },
  {
    countryCode: 'GH',
    name: 'Ghana',
    phoneCode: '+233',
    iconSrc: `${ICONS_API}app-translator-ghana-multicolor.svg`
  },
  {
    countryCode: 'GR',
    name: 'Greece',
    phoneCode: '+30',
    iconSrc: `${ICONS_API}app-translator-greece-multicolor.svg`
  },
  {
    countryCode: 'GT',
    name: 'Guatemala',
    phoneCode: '+502',
    iconSrc: `${ICONS_API}app-translator-guatemala-multicolor.svg`
  },
  {
    countryCode: 'GN',
    name: 'Guinea',
    phoneCode: '+224',
    iconSrc: `${ICONS_API}app-translator-guinea-multicolor.svg`
  },
  {
    countryCode: 'GY',
    name: 'Guyana',
    phoneCode: '+592',
    iconSrc: `${ICONS_API}app-translator-guyana-multicolor.svg`
  },
  {
    countryCode: 'HT',
    name: 'Haiti',
    phoneCode: '+509',
    iconSrc: `${ICONS_API}app-translator-haiti-multicolor.svg`
  },
  {
    countryCode: 'HN',
    name: 'Honduras',
    phoneCode: '+504',
    iconSrc: `${ICONS_API}app-translator-honduras-multicolor.svg`
  },
  {
    countryCode: 'HK',
    name: 'Hong Kong',
    phoneCode: '+852',
    iconSrc: `${ICONS_API}app-translator-hong-kong-multicolor.svg`
  },
  {
    countryCode: 'HU',
    name: 'Hungary',
    phoneCode: '+36',
    iconSrc: `${ICONS_API}app-translator-hungary-multicolor.svg`
  },
  {
    countryCode: 'IS',
    name: 'Iceland',
    phoneCode: '+354',
    iconSrc: `${ICONS_API}app-translator-iceland-multicolor.svg`
  },
  {
    countryCode: 'IN',
    name: 'India',
    phoneCode: '+91',
    iconSrc: `${ICONS_API}app-translator-india-multicolor.svg`
  },
  {
    countryCode: 'ID',
    name: 'Indonesia',
    phoneCode: '+62',
    iconSrc: `${ICONS_API}app-translator-indonesia-multicolor.svg`
  },
  {
    countryCode: 'IR',
    name: 'Iran',
    phoneCode: '+98',
    iconSrc: `${ICONS_API}app-translator-iran-multicolor.svg`
  },
  {
    countryCode: 'IQ',
    name: 'Iraq',
    phoneCode: '+964',
    iconSrc: `${ICONS_API}app-translator-iraq-multicolor.svg`
  },
  {
    countryCode: 'IE',
    name: 'Ireland',
    phoneCode: '+353',
    iconSrc: `${ICONS_API}app-translator-ireland-multicolor.svg`
  },
  {
    countryCode: 'IL',
    name: 'Israel',
    phoneCode: '+972',
    iconSrc: `${ICONS_API}app-translator-israel-multicolor.svg`
  },
  {
    countryCode: 'IT',
    name: 'Italy',
    phoneCode: '+39',
    iconSrc: `${ICONS_API}app-translator-italy-multicolor.svg`
  },
  {
    countryCode: 'JP',
    name: 'Japan',
    phoneCode: '+81',
    iconSrc: `${ICONS_API}app-translator-japan-multicolor.svg`
  },
  {
    countryCode: 'JO',
    name: 'Jordan',
    phoneCode: '+962',
    iconSrc: `${ICONS_API}app-translator-jordan-multicolor.svg`
  },
  {
    countryCode: 'KZ',
    name: 'Kazakhstan',
    phoneCode: '+7',
    iconSrc: `${ICONS_API}app-translator-kazakhstan-multicolor.svg`
  },
  {
    countryCode: 'KE',
    name: 'Kenya',
    phoneCode: '+254',
    iconSrc: `${ICONS_API}app-translator-kenia-multicolor.svg`
  },
  {
    countryCode: 'KW',
    name: 'Kuwait',
    phoneCode: '+965',
    iconSrc: `${ICONS_API}app-translator-kuwait-multicolor.svg`
  },
  {
    countryCode: 'KG',
    name: 'Kyrgyzstan',
    phoneCode: '+996',
    iconSrc: `${ICONS_API}app-translator-kyrgyzstan-multicolor.svg`
  },
  {
    countryCode: 'LA',
    name: 'Laos',
    phoneCode: '+856',
    iconSrc: `${ICONS_API}app-translator-laos-multicolor.svg`
  },
  {
    countryCode: 'LV',
    name: 'Latvia',
    phoneCode: '+371',
    iconSrc: `${ICONS_API}app-translator-latvia-multicolor.svg`
  },
  {
    countryCode: 'LB',
    name: 'Lebanon',
    phoneCode: '+961',
    iconSrc: `${ICONS_API}app-translator-lebanon-multicolor.svg`
  },
  {
    countryCode: 'LS',
    name: 'Lesotho',
    phoneCode: '+266',
    iconSrc: `${ICONS_API}app-translator-lesotho-multicolor.svg`
  },
  {
    countryCode: 'LI',
    name: 'Liechtenstein',
    phoneCode: '+423',
    iconSrc: `${ICONS_API}app-translator-liechtenstein-multicolor.svg`
  },
  {
    countryCode: 'LT',
    name: 'Lithuania',
    phoneCode: '+370',
    iconSrc: `${ICONS_API}app-translator-lithuania-multicolor.svg`
  },
  {
    countryCode: 'LU',
    name: 'Luxembourg',
    phoneCode: '+352',
    iconSrc: `${ICONS_API}app-translator-luxembourg-multicolor.svg`
  },
  {
    countryCode: 'MG',
    name: 'Madagascar',
    phoneCode: '+261',
    iconSrc: `${ICONS_API}app-translator-madagascar-multicolor.svg`
  },
  {
    countryCode: 'MW',
    name: 'Malawi',
    phoneCode: '+265',
    iconSrc: `${ICONS_API}app-translator-malawi-multicolor.svg`
  },
  {
    countryCode: 'MY',
    name: 'Malaysia',
    phoneCode: '+60',
    iconSrc: `${ICONS_API}app-translator-malaysia-multicolor.svg`
  },
  {
    countryCode: 'MV',
    name: 'Maldives',
    phoneCode: '+960',
    iconSrc: `${ICONS_API}app-translator-maldives-multicolor.svg`
  },
  {
    countryCode: 'ML',
    name: 'Mali',
    phoneCode: '+223',
    iconSrc: `${ICONS_API}app-translator-mali-multicolor.svg`
  },
  {
    countryCode: 'MT',
    name: 'Malta',
    phoneCode: '+356',
    iconSrc: `${ICONS_API}app-translator-malta-multicolor.svg`
  },
  {
    countryCode: 'MR',
    name: 'Mauritania',
    phoneCode: '+222',
    iconSrc: `${ICONS_API}app-translator-mauritania-multicolor.svg`
  },
  {
    countryCode: 'MX',
    name: 'Mexico',
    phoneCode: '+52',
    iconSrc: `${ICONS_API}app-translator-mexico-multicolor.svg`
  },
  {
    countryCode: 'MD',
    name: 'Moldova',
    phoneCode: '+373',
    iconSrc: `${ICONS_API}app-translator-moldova-multicolor.svg`
  },
  {
    countryCode: 'MN',
    name: 'Mongolia',
    phoneCode: '+976',
    iconSrc: `${ICONS_API}app-translator-mongolia-multicolor.svg`
  },
  {
    name: 'Mozambique',
    countryCode: 'MZ',
    phoneCode: '+258',
    iconSrc: `${ICONS_API}app-translator-mozambique-multicolor.svg`
  },
  {
    countryCode: 'MM',
    name: 'Myanmar',
    phoneCode: '+95',
    iconSrc: `${ICONS_API}app-translator-myanmar-multicolor.svg`
  },
  {
    countryCode: 'NA',
    name: 'Namibia',
    phoneCode: '+264',
    iconSrc: `${ICONS_API}app-translator-namibia-multicolor.svg`
  },
  {
    countryCode: 'NP',
    name: 'Nepal',
    phoneCode: '+977',
    iconSrc: `${ICONS_API}app-translator-nepal-multicolor.svg`
  },
  {
    countryCode: 'NL',
    name: 'Netherlands',
    phoneCode: '+31',
    iconSrc: `${ICONS_API}app-translator-netherlands-multicolor.svg`
  },
  {
    countryCode: 'NC',
    name: 'New Caledonia',
    phoneCode: '+687',
    iconSrc: `${ICONS_API}app-translator-france-multicolor.svg`
  },
  {
    countryCode: 'NZ',
    name: 'New Zealand',
    phoneCode: '+64',
    iconSrc: `${ICONS_API}app-translator-new-zealand-multicolor.svg`
  },
  {
    countryCode: 'NI',
    name: 'Nicaragua',
    phoneCode: '+505',
    iconSrc: `${ICONS_API}app-translator-nicaragua-multicolor.svg`
  },
  {
    countryCode: 'NG',
    name: 'Nigeria',
    phoneCode: '+234',
    iconSrc: `${ICONS_API}app-translator-nigeria-multicolor.svg`
  },
  {
    countryCode: 'MK',
    name: 'North Macedonia',
    phoneCode: '+389',
    iconSrc: `${ICONS_API}app-translator-north-macedonia-multicolor.svg`
  },
  {
    countryCode: 'NO',
    name: 'Norway',
    phoneCode: '+47',
    iconSrc: `${ICONS_API}app-translator-norway-multicolor.svg`
  },
  {
    countryCode: 'OM',
    name: 'Oman',
    phoneCode: '+968',
    iconSrc: `${ICONS_API}app-translator-oman-multicolor.svg`
  },
  {
    countryCode: 'PK',
    name: 'Pakistan',
    phoneCode: '+92',
    iconSrc: `${ICONS_API}app-translator-pakistan-multicolor.svg`
  },
  {
    countryCode: 'PA',
    name: 'Panama',
    phoneCode: '+507',
    iconSrc: `${ICONS_API}app-translator-panama-multicolor.svg`
  },
  {
    countryCode: 'PG',
    name: 'Papua New Guinea',
    phoneCode: '+675',
    iconSrc: `${ICONS_API}app-translator-papua-new-guinea-multicolor.svg`
  },
  {
    countryCode: 'PY',
    name: 'Paraguay',
    phoneCode: '+595',
    iconSrc: `${ICONS_API}app-translator-paraguay-multicolor.svg`
  },
  {
    countryCode: 'PE',
    name: 'Peru',
    phoneCode: '+51',
    iconSrc: `${ICONS_API}app-translator-peru-multicolor.svg`
  },
  {
    countryCode: 'PH',
    name: 'Philippines',
    phoneCode: '+63',
    iconSrc: `${ICONS_API}app-translator-philippines-multicolor.svg`
  },
  {
    countryCode: 'PL',
    name: 'Poland',
    phoneCode: '+48',
    iconSrc: `${ICONS_API}app-translator-poland-multicolor.svg`
  },
  {
    countryCode: 'PT',
    name: 'Portugal',
    phoneCode: '+351',
    iconSrc: `${ICONS_API}app-translator-portugal-multicolor.svg`
  },
  {
    countryCode: 'QA',
    name: 'Qatar',
    phoneCode: '+974',
    iconSrc: `${ICONS_API}app-translator-qatar-multicolor.svg`
  },
  {
    countryCode: 'CG',
    name: 'Republic of the Congo',
    phoneCode: '+242',
    iconSrc: `${ICONS_API}app-translator-republic-of-the-congo-multicolor.svg`
  },
  {
    countryCode: 'RO',
    name: 'Romania',
    phoneCode: '+40',
    iconSrc: `${ICONS_API}app-translator-romania-multicolor.svg`
  },
  {
    countryCode: 'RU',
    name: 'Russian Federation',
    phoneCode: '+7',
    iconSrc: `${ICONS_API}app-translator-russian-federation-multicolor.svg`
  },
  {
    countryCode: 'RW',
    name: 'Rwanda',
    phoneCode: '+250',
    iconSrc: `${ICONS_API}app-translator-rwanda-multicolor.svg`
  },
  {
    countryCode: 'KN',
    name: 'Saint Kitts and Nevis',
    phoneCode: '+1',
    iconSrc: `${ICONS_API}app-translator-st-kitts-and-nevis-multicolor.svg`
  },
  {
    countryCode: 'LC',
    name: 'Saint Lucia',
    phoneCode: '+1',
    iconSrc: `${ICONS_API}app-translator-saint-lucia-multicolor.svg`
  },
  {
    countryCode: 'MF',
    name: 'Saint Martin',
    phoneCode: '+590',
    iconSrc: `${ICONS_API}app-translator-st-martin-multicolor.svg`
  },
  {
    countryCode: 'VC',
    name: 'Saint Vincent and Grenadines',
    phoneCode: '+1',
    iconSrc: `${ICONS_API}app-translator-st-vincent-and-grenadines-multicolor.svg`
  },
  {
    countryCode: 'WS',
    name: 'Samoa',
    phoneCode: '+685',
    iconSrc: `${ICONS_API}app-translator-samoa-multicolor.svg`
  },
  {
    countryCode: 'SA',
    name: 'Saudi Arabia',
    phoneCode: '+966',
    iconSrc: `${ICONS_API}app-translator-saudi-arabia-multicolor.svg`
  },
  {
    countryCode: 'SN',
    name: 'Senegal',
    phoneCode: '+221',
    iconSrc: `${ICONS_API}app-translator-senegal-multicolor.svg`
  },
  {
    countryCode: 'RS',
    name: 'Serbia',
    phoneCode: '+381',
    iconSrc: `${ICONS_API}app-translator-serbia-multicolor.svg`
  },
  {
    countryCode: 'SL',
    name: 'Sierra Leone',
    phoneCode: '+232',
    iconSrc: `${ICONS_API}app-translator-sierra-leone-multicolor.svg`
  },
  {
    countryCode: 'SG',
    name: 'Singapore',
    phoneCode: '+65',
    iconSrc: `${ICONS_API}app-translator-singapore-multicolor.svg`
  },
  {
    countryCode: 'SK',
    name: 'Slovakia',
    phoneCode: '+421',
    iconSrc: `${ICONS_API}app-translator-slovakia-multicolor.svg`
  },
  {
    countryCode: 'SI',
    name: 'Slovenia',
    phoneCode: '+386',
    iconSrc: `${ICONS_API}app-translator-slovenia-multicolor.svg`
  },
  {
    countryCode: 'SO',
    name: 'Somalia',
    phoneCode: '+252',
    iconSrc: `${ICONS_API}app-translator-somalia-multicolor.svg`
  },
  {
    countryCode: 'ZA',
    name: 'South Africa',
    phoneCode: '+27',
    iconSrc: `${ICONS_API}app-translator-south-africa-multicolor.svg`
  },
  {
    countryCode: 'KR',
    name: 'South Korea',
    phoneCode: '+82',
    iconSrc: `${ICONS_API}app-translator-south-korea-multicolor.svg`
  },
  {
    countryCode: 'ES',
    name: 'Spain',
    phoneCode: '+34',
    iconSrc: `${ICONS_API}app-translator-spain-multicolor.svg`
  },
  {
    countryCode: 'LK',
    name: 'Sri Lanka',
    phoneCode: '+94',
    iconSrc: `${ICONS_API}app-translator-sri-lanka-multicolor.svg`
  },
  {
    countryCode: 'SJ',
    name: 'Svalbard and Jan Mayen',
    phoneCode: '+47',
    iconSrc: `${ICONS_API}app-translator-svalbard-and-jan-mayen-multicolor.svg`
  },
  {
    countryCode: 'SE',
    name: 'Sweden',
    phoneCode: '+46',
    iconSrc: `${ICONS_API}app-translator-sweden-multicolor.svg`
  },
  {
    countryCode: 'CH',
    name: 'Switzerland',
    phoneCode: '+41',
    iconSrc: `${ICONS_API}app-translator-switzerland-multicolor.svg`
  },
  {
    countryCode: 'TW',
    name: 'Taiwan',
    phoneCode: '+886',
    iconSrc: `${ICONS_API}app-translator-taiwan-multicolor.svg`
  },
  {
    countryCode: 'TJ',
    name: 'Tajikistan',
    phoneCode: '+992',
    iconSrc: `${ICONS_API}app-translator-tajikistan-multicolor.svg`
  },
  {
    countryCode: 'TZ',
    name: 'Tanzania',
    phoneCode: '+255',
    iconSrc: `${ICONS_API}app-translator-tanzania-multicolor.svg`
  },
  {
    countryCode: 'TH',
    name: 'Thailand',
    phoneCode: '+66',
    iconSrc: `${ICONS_API}app-translator-thailand-multicolor.svg`
  },
  {
    countryCode: 'TG',
    name: 'Togo',
    phoneCode: '+228',
    iconSrc: `${ICONS_API}app-translator-togo-multicolor.svg`
  },
  {
    countryCode: 'TT',
    name: 'Trinidad and Tobago',
    phoneCode: '+1',
    iconSrc: `${ICONS_API}app-translator-trinidad-and-tobago-multicolor.svg`
  },
  {
    countryCode: 'TN',
    name: 'Tunisia',
    phoneCode: '+216',
    iconSrc: `${ICONS_API}app-translator-tunisia-multicolor.svg`
  },
  {
    countryCode: 'TR',
    name: 'Turkey',
    phoneCode: '+90',
    iconSrc: `${ICONS_API}app-translator-turkey-multicolor.svg`
  },
  {
    countryCode: 'TM',
    name: 'Turkmenistan',
    phoneCode: '+993',
    iconSrc: `${ICONS_API}app-translator-turkmenistan-multicolor.svg`
  },
  {
    countryCode: 'UG',
    name: 'Uganda',
    phoneCode: '+256',
    iconSrc: `${ICONS_API}app-translator-uganda-multicolor.svg`
  },
  {
    countryCode: 'UA',
    name: 'Ukraine',
    phoneCode: '+380',
    iconSrc: `${ICONS_API}app-translator-ukraine-multicolor.svg`
  },
  {
    countryCode: 'AE',
    name: 'United Arab Emirates',
    phoneCode: '+971',
    iconSrc: `${ICONS_API}app-translator-united-arab-emirates-multicolor.svg`
  },
  {
    countryCode: 'GB',
    name: 'United Kingdom',
    phoneCode: '+44',
    iconSrc: `${ICONS_API}app-translator-united-kingdom-multicolor.svg`
  },
  {
    countryCode: 'US',
    name: 'United States',
    phoneCode: '+1',
    iconSrc: `${ICONS_API}app-translator-united-states-multicolor.svg`
  },
  {
    countryCode: 'UY',
    name: 'Uruguay',
    phoneCode: '+598',
    iconSrc: `${ICONS_API}app-translator-uruguay-multicolor.svg`
  },
  {
    countryCode: 'UZ',
    name: 'Uzbekistan',
    phoneCode: '+998',
    iconSrc: `${ICONS_API}app-translator-uzbekistan-multicolor.svg`
  },
  {
    countryCode: 'VE',
    name: 'Venezuela',
    phoneCode: '+58',
    iconSrc: `${ICONS_API}app-translator-venezuela-multicolor.svg`
  },
  {
    countryCode: 'VN',
    name: 'Vietnam',
    phoneCode: '+84',
    iconSrc: `${ICONS_API}app-translator-vietnam-multicolor.svg`
  },
  {
    countryCode: 'YE',
    name: 'Yemen',
    phoneCode: '+967',
    iconSrc: `${ICONS_API}app-translator-yemen-multicolor.svg`
  },
  {
    countryCode: 'ZM',
    name: 'Zambia',
    phoneCode: '+260',
    iconSrc: `${ICONS_API}app-translator-zambia-multicolor.svg`
  },
  {
    countryCode: 'ZW',
    name: 'Zimbabwe',
    phoneCode: '+263',
    iconSrc: `${ICONS_API}app-translator-zimbabwe-multicolor.svg`
  }
] satisfies Country[];

/**
 * @deprecated use useGetCountries hook to get countries instead of this
 */
export const USA: Country = {
  countryCode: 'US',
  name: 'United States',
  phoneCode: '+1',
  iconSrc: `${ICONS_API}app-translator-united-states-multicolor.svg`
};

export const countryKeysToIgnore = [
  'Afghanistan',
  'Albania',
  'Armenia',
  'Ascension Island',
  'Australia',
  'Azerbaijan',
  'Bangladesh',
  'Barbados',
  'Belarus',
  'Bolivia',
  'Bosnia and Herzegovina',
  'Brazil',
  'Bulgaria',
  'Cabo Verde',
  'Cambodia',
  'Canada',
  'Caribbean Netherlands',
  'China',
  'Croatia',
  'Czech Republic',
  'Democratic Republic of the Congo',
  'Denmark',
  'Egypt',
  'Eritrea',
  'Estonia',
  'Eswatini',
  'Ethiopia',
  'Finland',
  'France',
  'Georgia',
  'Germany',
  'Ghana',
  'Greece',
  'Haiti',
  'Hungary',
  'Iceland',
  'India',
  'Indonesia',
  'Iran',
  'Iraq',
  'Ireland',
  'Israel',
  'Italy',
  'Japan',
  'Kazakhstan',
  'Kyrgyzstan',
  'Laos',
  'Latvia',
  'Lesotho',
  'Lithuania',
  'Luxembourg',
  'Madagascar',
  'Malawi',
  'Malaysia',
  'Maldives',
  'Mali',
  'Malta',
  'Mexico',
  'Mongolia',
  'Myanmar',
  'Nepal',
  'Netherlands',
  'New Zealand',
  'Nigeria',
  'North Macedonia',
  'Norway',
  'Pakistan',
  'Paraguay',
  'Peru',
  'Philippines',
  'Poland',
  'Portugal',
  'Romania',
  'Russian Federation',
  'Rwanda',
  'Saint Kitts and Nevis',
  'Saint Lucia',
  'Saint Martin',
  'Saint Vincent and Grenadines',
  'Samoa',
  'Saudi Arabia',
  'Serbia',
  'Sierra Leone',
  'Slovakia',
  'Slovenia',
  'Somalia',
  'South Africa',
  'South Korea',
  'Spain',
  'Sri Lanka',
  'Svalbard and Jan Mayen',
  'Sweden',
  'Taiwan',
  'Tajikistan',
  'Tanzania',
  'Thailand',
  'Togo',
  'Turkey',
  'Turkmenistan',
  'Uganda',
  'Ukraine',
  'United Kingdom',
  'United States',
  'Uzbekistan',
  'Vietnam',
  'Zimbabwe',
  'Switzerland',
  'Belgium',
  'Singapore',
  'Mozambique',
  'Kenya',
  'Colombia',
  'Sudan',
  'Algeria',
  'Austria',
  'Argentina',
  'Morocco',
  'Angola',
  'Venezuela',
  'Chile',
  'Ecuador',
  'Guatemala',
  'Papua New Guinea',
  'Tunisia',
  'Libya',
  'Cameroon',
  'Mauritania',
  'Senegal',
  'Zambia',
  'Nicaragua',
  'Guyana',
  'Uruguay',
  'Honduras',
  'Hong Kong',
  'Bolivia',
  'Panama',
  'Costa Rica',
  'Cuba',
  'Dominican Republic',
  'El Salvador',
  'Jamaica',
  'Guinea',
  'Gambia',
  'Gabon',
  'Republic of the Congo',
  'Equatorial Guinea',
  'Benin',
  'Burkina Faso',
  'Burundi',
  'Botswana',
  'Malawi',
  'Mali',
  'Namibia',
  'Oman',
  'Yemen',
  'Syria',
  'Jordan',
  'Lebanon',
  'Kuwait',
  'Qatar',
  'Bahrain',
  'United Arab Emirates',
  'Palestine',
  'Cyprus',
  'Brunei',
  'Moldova',
  'Montenegro',
  'Andorra',
  'Liechtenstein',
  'Monaco',
  'New Caledonia',
  'Trinidad and Tobago',
  'French Polynesia'
];

export function translateCountryLabels(
  t: undefined | ((name: string) => string)
) {
  if (typeof t !== 'function') {
    return COUNTRIES;
  }

  return COUNTRIES.map((country) => ({
    ...country,
    name: t(country.name)
  }));
}
